import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_APPRECIATION, ADD_APPRECIATION_FAILED, ADD_APPRECIATION_SUCCESS, APPRECIATION, APPRECIATION_FAILED, APPRECIATION_SUCCESS, UPDATE_APPRECIATION, UPDATE_APPRECIATION_FAILED, UPDATE_APPRECIATION_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getAppreciations = () => async (dispatch) => {
  dispatch({
    type: APPRECIATION,
  });
  try {
    let response = await api(`appreciation/appreciationList`, "get", {}, getAuthHeader());
    dispatch({
      type: APPRECIATION_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Appreciation list error ====>", error);
    return dispatch({
      type: APPRECIATION_FAILED,
      payload: error?.message,
    });
  }
};

export const addAppreciation = (data) => async dispatch => {
  dispatch({
    type: ADD_APPRECIATION
  })
  try {
    let response = await api(`appreciation/add`, 'post', data, getAuthHeader())
    console.log('add appreciation data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_APPRECIATION_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding appreciation error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_APPRECIATION_FAILED,
      payload: error?.message
    })
  }
}

export const updateAppreciation = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_APPRECIATION
  })
  try {
    let response = await api(`appreciation/update/${id}`, 'put', data, getAuthHeader())
    console.log('update appreciation data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_APPRECIATION_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating appreciation error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_APPRECIATION_FAILED,
      payload: error?.message
    })
  }
}